// src/components/awareness-placement/awareness-placement.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment ApplyButtonFragment on CreditCardApplyButton {\n    action {\n      ... on UILinkAction {\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        accessibility\n        resource {\n          value\n        }\n        target\n      }\n      ... on CreditCardEmbeddedApplyAction {\n        ...CreditCardEmbeddedApplyActionFragment\n      }\n    }\n    button {\n      ... on UIPrimaryButton {\n        primary\n        disabled\n      }\n      ... on UISecondaryButton {\n        primary\n        disabled\n      }\n      ... on UITertiaryButton {\n        primary\n        disabled\n      }\n    }\n  }\n\n  fragment CreditCardEmbeddedApplyActionFragment on CreditCardEmbeddedApplyAction {\n    accessibility\n    container {\n      sheet {\n        closeAnalytics {\n          linkName\n          referrerId\n        }\n        closeText\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardBadgeFragment on EGDSStandardBadge {\n    accessibility\n    text\n    size\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    decorative\n    text\n    theme\n    weight\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      ... on UILinkAction {\n        accessibility\n        analytics {\n          ...ClientSideAnalyticsFragment\n        }\n        resource {\n          value\n        }\n        target\n      }\n    }\n    text\n  }\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      ... on UILinkAction {\n        accessibility\n        resource {\n          value\n        }\n        target\n      }\n    }\n    text\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextInlineContentFragment on EGDSSpannableTextItem {\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSStandardLinkFragment\n    ...EGDSInlineLinkFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextInlineContentFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment ImageFragment on Image {\n    __typename\n    description\n    url\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment AwarenessTemplateFragment on CreditCardAwarenessPlacement {\n    backgroundImage {\n      ...ImageFragment\n    }\n    badge {\n      ...EGDSStandardBadgeFragment\n    }\n    cta {\n      ...ApplyButtonFragment\n    }\n    heading {\n      ...EGDSPlainTextFragment\n    }\n    headingNote {\n      ...EGDSPlainTextFragment\n    }\n    image {\n      ...ImageFragment\n    }\n    impressionAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    subHeading {\n      ...EGDSPlainTextFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  query CreditCardAwarenessPlacement($context: ContextInput!) {\n    creditCardAwarenessPlacement(context: $context) {\n      ...AwarenessTemplateFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import React12 from "react";
import { gql as gql12, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ViewLarge, ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/awareness-placement/__private/awareness-template-fragment.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSBadgeStandardThemes } from "@egds/react-core/badge";
import { EGDSCard, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSHeading } from "@egds/react-core/text";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/common/fragments/client-side-analytics.ts
import { gql } from "@apollo/client";
var ClientSideAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/apply-button/apply-button.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
import { useDialog } from "@shared-ui/dialog-context";
// ../internal/src/components/common/button/button.tsx
import React from "react";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton } from "uitk-react-button";
var Button = function(props) {
    var children = props.children, isFullWidth = props.isFullWidth, onClick = props.onClick, size = props.size, typeName = props.typeName, otherProps = _object_without_properties(props, [
        "children",
        "isFullWidth",
        "onClick",
        "size",
        "typeName"
    ]);
    switch(typeName){
        case "UIPrimaryButton":
            return /* @__PURE__ */ React.createElement(UitkPrimaryButton, _object_spread({
                onClick: onClick,
                isFullWidth: isFullWidth,
                size: size
            }, otherProps), children);
        case "UISecondaryButton":
            return /* @__PURE__ */ React.createElement(UitkSecondaryButton, _object_spread({
                onClick: onClick,
                isFullWidth: isFullWidth,
                size: size
            }, otherProps), children);
        case "UITertiaryButton":
            return /* @__PURE__ */ React.createElement(UitkTertiaryButton, _object_spread({
                onClick: onClick,
                isFullWidth: isFullWidth,
                size: size
            }, otherProps), children);
        default:
            return null;
    }
};
// ../internal/src/components/apply-button/apply-button.tsx
var fragment = gql2(_templateObject1(), ClientSideAnalyticsFragment);
var ApplyButton = function(param) {
    var data = param.data, isFullWidth = param.isFullWidth, onClick = param.onClick, size = param.size;
    var _useDialog = _sliced_to_array(useDialog("apply-sheet", "apply-sheet", false), 2), _ = _useDialog[0], dialogActions = _useDialog[1];
    var action = data.action, button = data.button;
    var applyButtonSize = size !== null && size !== void 0 ? size : EGDSButtonSize.MEDIUM;
    var openDialog = function() {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        dialogActions.openDialog();
    };
    var _action_accessibility, _action_accessibility1;
    return action.__typename === "UILinkAction" ? /* @__PURE__ */ React2.createElement(Button, _object_spread_props(_object_spread({
        "aria-label": (_action_accessibility = action.accessibility) !== null && _action_accessibility !== void 0 ? _action_accessibility : void 0,
        isFullWidth: isFullWidth
    }, !button.disabled && {
        tag: "a",
        href: action.resource.value
    }), {
        size: applyButtonSize,
        typeName: button.__typename,
        disabled: button.disabled,
        onClick: onClick
    }), button.primary) : /* @__PURE__ */ React2.createElement(Button, {
        "aria-label": (_action_accessibility1 = action.accessibility) !== null && _action_accessibility1 !== void 0 ? _action_accessibility1 : void 0,
        isFullWidth: isFullWidth,
        onClick: openDialog,
        size: applyButtonSize,
        typeName: button.__typename,
        disabled: button.disabled
    }, button.primary);
};
ApplyButton.fragment = fragment;
ApplyButton.displayName = "ApplyButton";
// ../internal/src/components/egds-standard-badge/egds-standard-badge.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSBadgeSize, EGDSBadgeStandard } from "@egds/react-core/badge";
var fragment2 = gql3(_templateObject2());
var EGDSStandardBadge = function(param) {
    var data = param.data, theme = param.theme;
    var accessibility = data.accessibility, text = data.text, size = data.size;
    var _ref;
    var badgeSize = (_ref = size && EGDSBadgeSize[size]) !== null && _ref !== void 0 ? _ref : EGDSBadgeSize.LARGE;
    return /* @__PURE__ */ React3.createElement(EGDSBadgeStandard, {
        a11yText: accessibility !== null && accessibility !== void 0 ? accessibility : void 0,
        theme: theme,
        size: badgeSize,
        text: text !== null && text !== void 0 ? text : void 0
    });
};
EGDSStandardBadge.fragment = fragment2;
EGDSStandardBadge.displayName = "EGDSStandardBadge";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var fragment3 = gql4(_templateObject3());
var EGDSPlainText = function(param) {
    var align = param.align, data = param.data, inline = param.inline, size = param.size, theme = param.theme, weight = param.weight;
    var text = data.text;
    return /* @__PURE__ */ React4.createElement(EGDSText, {
        align: align,
        size: size,
        inline: inline,
        theme: theme,
        weight: weight
    }, text);
};
EGDSPlainText.fragment = fragment3;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var _obj;
// ../internal/src/components/egds-text/__private/text-decorative.ts
var textDecorationMapper = (_obj = {}, _define_property(_obj, "SUBSCRIPT" /* SUBSCRIPT */ , "sub"), _define_property(_obj, "SUPERSCRIPT" /* SUPERSCRIPT */ , "sup"), _define_property(_obj, "LINE_THROUGH" /* LINE_THROUGH */ , "s"), _obj);
var _obj1;
// ../internal/src/components/egds-text/__private/text-theme.ts
var textThemeMapper = (_obj1 = {}, _define_property(_obj1, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj1, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj1, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj1, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj1, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj1, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj1, "INVERSE" /* INVERSE */ , "inverse"), _obj1);
var _obj2;
// ../internal/src/components/egds-text/__private/text-weight.ts
var textWeightMapper = (_obj2 = {}, _define_property(_obj2, "BOLD" /* BOLD */ , "bold"), _define_property(_obj2, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj2, "REGULAR" /* REGULAR */ , "regular"), _obj2);
// ../internal/src/components/egds-text/egds-stylized-text.tsx
var fragment4 = gql5(_templateObject4());
var EGDSStylizedText = function(param) {
    var align = param.align, inline = param.inline, data = param.data, size = param.size, whiteSpace = param.whiteSpace, weightOverride = param.weightOverride;
    var decorative = data.decorative, text = data.text, theme = data.theme, weight = data.weight;
    var themeProps = theme ? textThemeMapper[theme] : void 0;
    var weightProps = weightOverride || (weight ? textWeightMapper[weight] : void 0);
    var TextDecorationTag = decorative ? textDecorationMapper[decorative] : void 0;
    return /* @__PURE__ */ React5.createElement(EGDSText2, {
        align: align,
        inline: inline,
        size: size,
        theme: themeProps,
        weight: weightProps,
        whiteSpace: whiteSpace
    }, TextDecorationTag ? /* @__PURE__ */ React5.createElement(TextDecorationTag, null, text) : /* @__PURE__ */ React5.createElement(React5.Fragment, null, text));
};
EGDSStylizedText.fragment = fragment4;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/spannable-text/egds-spannable-text.tsx
import React9, { Fragment } from "react";
import { gql as gql9 } from "@apollo/client";
// ../internal/src/components/egds-text/spannable-text/egds-spannable-text-inline-content.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/egds-text/egds-inline-link.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var fragment5 = gql6(_templateObject5(), ClientSideAnalyticsFragment);
var EGDSInlineLink = function(param) {
    var data = param.data, linkSize = param.linkSize, onClick = param.onClick;
    var text = data.text, action = data.action;
    var trackClick = useClickTracker();
    var onClickTracking = function() {
        var _action_analytics = action.analytics, referrerId = _action_analytics.referrerId, linkName = _action_analytics.linkName;
        if (referrerId && linkName) {
            trackClick(referrerId, linkName);
        }
    };
    var onClickWrapper = function(e) {
        onClickTracking();
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    var _action_accessibility;
    return /* @__PURE__ */ React6.createElement(UitkLink, {
        inline: true,
        size: linkSize,
        onClick: onClickWrapper
    }, /* @__PURE__ */ React6.createElement("a", {
        href: action.resource.value,
        target: action.target === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "",
        rel: "noreferrer",
        "aria-label": (_action_accessibility = action.accessibility) !== null && _action_accessibility !== void 0 ? _action_accessibility : void 0
    }, text));
};
EGDSInlineLink.fragment = fragment5;
EGDSInlineLink.displayName = "sharedui-EGDSInlineLink";
// ../internal/src/components/egds-text/egds-standard-link.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkLink as UitkLink2 } from "uitk-react-link";
var fragment6 = gql7(_templateObject6());
var EGDSStandardLink = function(param) {
    var data = param.data, linkSize = param.linkSize;
    var text = data.text, action = data.action;
    var _action_accessibility;
    return /* @__PURE__ */ React7.createElement(UitkLink2, {
        size: linkSize
    }, /* @__PURE__ */ React7.createElement("a", {
        href: action.resource.value,
        target: action.target === "EXTERNAL" /* EXTERNAL */  ? "_blank" : "",
        rel: "noreferrer",
        "aria-label": (_action_accessibility = action.accessibility) !== null && _action_accessibility !== void 0 ? _action_accessibility : void 0
    }, text));
};
EGDSStandardLink.fragment = fragment6;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/egds-text/spannable-text/egds-spannable-text-inline-content.tsx
var fragment7 = gql8(_templateObject7(), EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSStandardLink.fragment, EGDSInlineLink.fragment);
var EGDSSpannableTextInlineContent = function(param) {
    var size = param.size, align = param.align, theme = param.theme, data = param.data, weight = param.weight;
    switch(data.__typename){
        case "EGDSStylizedText":
            return /* @__PURE__ */ React8.createElement(EGDSStylizedText, {
                align: align,
                data: data,
                size: size,
                weightOverride: weight,
                inline: true
            });
        case "EGDSPlainText":
            return /* @__PURE__ */ React8.createElement(EGDSPlainText, {
                data: data,
                size: size,
                align: align,
                inline: true,
                theme: theme,
                weight: weight
            });
        case "EGDSStandardLink":
            return /* @__PURE__ */ React8.createElement(EGDSStandardLink, {
                data: data
            });
        case "EGDSInlineLink":
            return /* @__PURE__ */ React8.createElement(EGDSInlineLink, {
                data: data
            });
        default:
            return null;
    }
};
EGDSSpannableTextInlineContent.fragment = fragment7;
EGDSSpannableTextInlineContent.displayName = "EGDSSpannableTextInlineContent";
// ../internal/src/components/egds-text/spannable-text/egds-spannable-text.tsx
var fragment8 = gql9(_templateObject8(), EGDSSpannableTextInlineContent.fragment);
var EGDSSpannableText = function(param) {
    var align = param.align, data = param.data, size = param.size, theme = param.theme, weight = param.weight;
    var _data_inlineContent;
    if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
        return /* @__PURE__ */ React9.createElement(React9.Fragment, null, data.inlineContent.map(function(item, index) {
            return /* @__PURE__ */ React9.createElement(Fragment, {
                key: "inline-content-".concat(index)
            }, /* @__PURE__ */ React9.createElement(EGDSSpannableTextInlineContent, {
                align: align,
                data: item,
                size: size,
                theme: theme,
                weight: weight
            }), " ");
        }));
    }
    return null;
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/image/image.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
var fragment9 = gql10(_templateObject9());
var Image = function(param) {
    var data = param.data, imageFit = param.imageFit, ratio = param.ratio;
    var description = data.description, url = data.url;
    return /* @__PURE__ */ React10.createElement(EGDSFigure, {
        ratio: ratio,
        imageFit: imageFit
    }, /* @__PURE__ */ React10.createElement(EGDSImage, {
        alt: description,
        src: url
    }));
};
Image.fragment = fragment9;
Image.displayName = "Image";
// src/components/awareness-placement/__private/awareness-template-fragment.tsx
var fragment10 = gql11(_templateObject10(), ClientSideAnalyticsFragment, Image.fragment, EGDSStandardBadge.fragment, ApplyButton.fragment, EGDSPlainText.fragment);
var AwarenessTemplate = function(param) {
    var data = param.data, options = param.options, withCardLink = param.withCardLink;
    var sectionPadding = options.sectionPadding, gridImage = options.gridImage, badgePadding = options.badgePadding, cardsPadding = options.cardsPadding, headingPadding = options.headingPadding;
    var heading = data.heading, headingNote = data.headingNote, subHeading = data.subHeading, backgroundImage = data.backgroundImage, badge = data.badge, cta = data.cta, image = data.image, impressionAnalytics = data.impressionAnalytics;
    var action = cta.action;
    var trackClick = useClickTracker2();
    var onPlacementClicked = function() {
        if (action.__typename === "UILinkAction") {
            var analytics = action.analytics;
            trackClick(analytics.referrerId, analytics.linkName);
        }
    };
    return /* @__PURE__ */ React11.createElement(IntersectionTracker, {
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.linkName
    }, /* @__PURE__ */ React11.createElement(EGDSCard, {
        backgroundTheme: "secondary"
    }, withCardLink && action.__typename === "UILinkAction" && /* @__PURE__ */ React11.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */ React11.createElement(EGDSCardLink, null, /* @__PURE__ */ React11.createElement("a", {
        href: action.resource.value,
        onClick: onPlacementClicked
    }, action.accessibility))), /* @__PURE__ */ React11.createElement(EGDSLayoutGrid, {
        areas: {
            small: [
                "imageGrid",
                "contentGrid"
            ],
            medium: [
                "contentGrid imageGrid"
            ]
        }
    }, /* @__PURE__ */ React11.createElement(EGDSLayoutGridItem, {
        area: "imageGrid"
    }, /* @__PURE__ */ React11.createElement(EGDSLayoutGrid, {
        autoRows: gridImage
    }, /* @__PURE__ */ React11.createElement(EGDSFigure2, null, /* @__PURE__ */ React11.createElement(EGDSImage2, {
        src: backgroundImage.url,
        alt: backgroundImage.description
    })))), /* @__PURE__ */ React11.createElement(EGDSLayoutGridItem, {
        area: "contentGrid"
    }, /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: sectionPadding
    }, /* @__PURE__ */ React11.createElement("div", null, (badge === null || badge === void 0 ? void 0 : badge.__typename) === "EGDSStandardBadge" && /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: badgePadding
    }, /* @__PURE__ */ React11.createElement(EGDSStandardBadge, {
        data: badge,
        theme: EGDSBadgeStandardThemes.EMPHASIS
    }))), /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: headingPadding
    }, /* @__PURE__ */ React11.createElement(EGDSHeading, {
        size: 5,
        tag: "h2"
    }, heading.text)), subHeading && /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSPlainText, {
        data: subHeading
    }))), headingNote && /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(EGDSPlainText, {
        data: headingNote
    }))), /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(ApplyButton, {
        data: cta,
        onClick: onPlacementClicked
    }))), /* @__PURE__ */ React11.createElement(EGDSLayoutPosition, {
        cloneElement: true,
        type: "absolute",
        position: {
            left: "center",
            top: "center",
            zindex: "layer1"
        }
    }, /* @__PURE__ */ React11.createElement(EGDSSpacing, {
        padding: cardsPadding
    }, /* @__PURE__ */ React11.createElement(EGDSLayoutGrid, {
        autoRows: [
            "152px"
        ],
        autoColumns: [
            "304px"
        ]
    }, /* @__PURE__ */ React11.createElement(EGDSFigure2, {
        imageFit: "contain"
    }, /* @__PURE__ */ React11.createElement(EGDSImage2, {
        src: image.url,
        alt: image.description
    })))))))))));
};
AwarenessTemplate.fragment = fragment10;
AwarenessTemplate.displayName = "AwarenessTemplateFragment";
// src/components/awareness-placement/awareness-placement.tsx
var __Query = gql12(_templateObject11(), AwarenessTemplate.fragment);
var smallViewportOptions = {
    sectionPadding: {
        inline: "six",
        blockend: "six",
        blockstart: "sixteen"
    },
    gridImage: [
        "236px"
    ],
    badgePadding: {
        blockstart: "eight"
    },
    cardsPadding: {
        blockend: "sixteen"
    },
    headingPadding: {
        blockstart: "two"
    }
};
var largeViewportOptions = {
    sectionPadding: {
        inlinestart: "eight",
        inlineend: "sixteen",
        block: "six"
    },
    headingPadding: {
        blockstart: "four"
    },
    gridImage: [
        "220px"
    ]
};
var mediumViewportOptions = {
    sectionPadding: {
        inlinestart: "eight",
        inlineend: "sixteen",
        block: "six"
    },
    headingPadding: {
        blockstart: "four"
    }
};
var AwarenessPlacement = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr;
    var context = useBexApi().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        context: {
            useApq: true
        },
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.creditCardAwarenessPlacement) {
        return null;
    }
    var creditCardAwarenessPlacement = data.creditCardAwarenessPlacement;
    return /* @__PURE__ */ React12.createElement(Viewport, null, /* @__PURE__ */ React12.createElement(ViewSmall, null, /* @__PURE__ */ React12.createElement(AwarenessTemplate, {
        data: creditCardAwarenessPlacement,
        options: smallViewportOptions,
        withCardLink: true
    })), /* @__PURE__ */ React12.createElement(ViewMedium, null, /* @__PURE__ */ React12.createElement(AwarenessTemplate, {
        data: creditCardAwarenessPlacement,
        options: mediumViewportOptions
    })), /* @__PURE__ */ React12.createElement(ViewLarge, null, /* @__PURE__ */ React12.createElement(AwarenessTemplate, {
        data: creditCardAwarenessPlacement,
        options: largeViewportOptions
    })));
};
AwarenessPlacement.displayName = "sharedui-AwarenessPlacement";
export { AwarenessPlacement };
//# sourceMappingURL=index.js.map